<template>
  <div>
    <template v-if="loading">
      <slot name="loading">{{ loadingText }}</slot>
    </template>
    <template v-else-if="failed">
      <slot name="failed">{{ failedText }}</slot>
    </template>
    <slot v-else>
      <slot name="loaded"></slot>
    </slot>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      loadingText: {
        type: String,
        default: 'Loading...',
      },
      loading: {
        type: Boolean,
        default: true,
      },
      failed: {
        type: Boolean,
        default: false,
      },
      failedText: {
        type: String,
        default: 'Loading Failed.',
      },
    }
  })
</script>